import React from "react";
import { useNavigate } from "react-router-dom";
import pdfFile from "../../assets/privacypolicy-GPD.pdf";

export const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();
  const pdfUrl = `${pdfFile}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`;
  return (
    <div
      className="fixed inset-0 w-full max-w-full min-h-[100dvh] overflow-x-hidden overflow-y-hidden bg-neutral-100"
      style={{ height: "100dvh" }}
    >
      <button
        type="button"
        onClick={() => {
          if (window.history.length > 1) navigate(-1);
          else navigate("/");
        }}
        className="absolute bottom-4 left-4 lg:left-6 z-10 flex items-center justify-center rounded-full bg-white/90 hover:bg-white shadow-lg transition-all text-neutral-700 hover:text-neutral-900 w-10 h-10 cursor-pointer"
        aria-label="Volver"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 sm:w-6 sm:h-6"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
      </button>
      <iframe
        src={pdfUrl}
        title="Política de privacidad"
        className="absolute inset-0 w-full max-w-full h-full border-0 min-h-0 overflow-x-hidden"
        style={{ maxWidth: "100vw" }}
      />
    </div>
  );
};
